import gql from 'graphql-tag';

export default gql`
  query {
    bestSellers {
        items {
          id
          categories {
            id
          }
          rating_summary
          review_count
        }
    }
  }
`;
